import { Component, ViewChild } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { NotificationsCatalogKeys } from '../models/NotificationsCatalogKeys';
import { GenericTableComponent } from '../../shared/features/generic-table/components/generic-table.component';
import { CatalogPaginationRequest } from '../../shared/models/CatalogPagination/CatalogPaginationRequest';
import { FilterRequest } from '../../shared/models/Filter/FilterRequest';
import { NotificationService } from '../services/Notification.service';

@Component({
  selector: 'app-notificationPage',
  templateUrl: './notificationPage.component.html',
  styleUrls: ['./notificationPage.component.css']
})
export class NotificationPageComponent {

  @ViewChild(GenericTableComponent) child;

  columnHeader : NotificationsCatalogKeys = {
    DetonatorName: { displayName: "Nombre", filterable: false, activeFilter: null } ,
    CreatedIn: { displayName: "Fecha", filterable: false, activeFilter: null } ,
    Identifier: { displayName: "VIN", filterable: false, activeFilter: null } ,
    NotificationType: { displayName: "Tipo de notificacion", filterable: true, activeFilter: null } ,
    EmailAlert: { displayName: "Correos notificados", filterable: false, activeFilter: null } ,
    AlarmDetails: { displayName: "Detalles de la alarma", filterable: false, activeFilter: null } ,
  };

  catalogPaginationRequest: CatalogPaginationRequest = {
          page: 1,
          dato: "",
          getInactive: false,
          filters: []
  }

  hasInactives: boolean = false;
  hasEditables: boolean = false;
  hasDeletables: boolean = false;
  filtersRequest : FilterRequest[] = [];
  filterOptions: { [key: string]: string[] } = {};

  tableData$: Observable<any[]> = new Observable<any[]>();
  tableData: any[];
  controllerName: string;
  paginador: number;
  isMapUnified: boolean;
  isAdmin: any;

  subscription_getData: Subscription;
  subscription_getDataCount: Subscription;
  subscription_getDataFileterValues: Subscription;

  constructor(public notificationCatalogService: NotificationService) {
    this.controllerName = "Notification"
  }

  ngOnInit() {
    this.EndSubscriptions();
    this.getFilters();
    this.getData();
  }

  ngOnDestroy(): void {
    this.EndSubscriptions();
  }

  EndSubscriptions(){
    if(this.subscription_getData)
      this.subscription_getData.unsubscribe();
    if(this.subscription_getDataCount)
      this.subscription_getDataCount.unsubscribe();
    if(this.subscription_getDataFileterValues)
      this.subscription_getDataFileterValues.unsubscribe();
  }

  getFilters(){
    var filterKeys = Object.keys(this.columnHeader).filter(key => this.columnHeader[key].filterable);
    this.filtersRequest = filterKeys.map(key => ({
      key: key,
      value: "" 
    }));
    this.subscription_getDataFileterValues = this.notificationCatalogService.getFilterValues(this.filtersRequest).subscribe(data=>{
      filterKeys.forEach(column => {
        this.filterOptions[column] = data.result.find(x => x.key == column).values;
      });
      console.log("filterValues datos",data, this.filterOptions);
    },(error)=>{

    });
  }

  getData(){
    this.subscription_getDataCount = this.notificationCatalogService.getCount(this.catalogPaginationRequest).subscribe(data=>{
      this.paginador = data.result[0];
      console.log("notification datos",this.paginador);
    },(error)=>{

    });
    this.subscription_getData = this.notificationCatalogService.getPage(this.catalogPaginationRequest).subscribe(data=>{
      console.log("notification page 1",data);
      if(data.isSuccess==true)
      {
        // Apply condition on edit and delete button
      this.tableData = data.result;
      this.tableData.map(item => {
        item['IsEditable'] = this.hasEditables;
        item['IsDeletable'] = this.hasDeletables;
      // if (item['client'] === 'Geointelligent') {
      // }
      // return item;
      });
      this.child.setData(this.tableData, this.paginador);

      }
    },(error)=>{

    });
  }

}
